























import { Box, Button, CustomLink, Flex } from '../../atoms'
import { PasswordInputGroup } from '../../molecules'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { APP_MODULE, DISABLED_SOCIAL, TRANSLATE  } from '../../../store/modules/app/constant'
import  { AUTH_MODULE, FORGOT_EMAIL_LOGIN } from '../../../store/modules/auth/constant'
import { mapGetters, mapActions } from 'vuex'
import {
  EMAIL_LOGIN, SET_FORGOT_EMAIL_LOGIN
} from '../../../store/modules/auth/constant'

@Component({
  components: {
    Box,
    Button,
    PasswordInputGroup,
    Flex,
    CustomLink,
  },
  computed: {
    ...mapGetters(APP_MODULE, [DISABLED_SOCIAL, FORGOT_EMAIL_LOGIN, TRANSLATE])
  },
  methods: {
    ...mapActions(AUTH_MODULE, [EMAIL_LOGIN, SET_FORGOT_EMAIL_LOGIN])
  }
})
export default class LoginBox extends Vue {
  @Prop({ required: true, type: String }) readonly value!: string
  @Prop({ type: String, default: '' }) readonly error?: string
  @Prop({ type: String, default: '' }) readonly email?: string

  get formError(): boolean {
    return this.error !== ''
  }
  goToForgotPassword() {
      (this as any)[SET_FORGOT_EMAIL_LOGIN](this.email)
      this.$router.push({ path: '/forgot-password'})
    }
}
